<template>
  <div class="order-index">
    <div v-if="isActive == 0">
      <div class="top">
        <p class="title">{{ title }}</p>
        <div class="content-container" ref="contentContainer">
          <p class="content" :class="{ collapsed: !expanded }">
            &nbsp;&nbsp;{{ content }}
          </p>
          <button
            class="toggle-btn"
            @click="expanded = !expanded"
            v-if="isOverflowing"
          >
            {{ expanded ? "收起" : "展开" }}
          </button>
        </div>
      </div>
      <div class="zhong">
        <div class="tishi">
          <img
            src="../assets/image/order_img11.png"
            alt=""
            style="width: 20px; height: 20px"
          />
          <div style="margin-left: 5px">预约成功后可在下方'我的'里查看</div>
        </div>
        <div>
          <img
            v-if="timeLength > 1"
            @click="selectTime"
            src="../assets/image/order_img1.png"
            alt=""
            class="timeImg"
          />
        </div>
      </div>
      <div class="bottom">
        <div v-for="(item, index) in examList" :key="index" class="bottom-item">
          <!-- <div class="review-badge">
            <img
              v-if="item.reservationStuNum == item.stuLimit"
              src="../assets/image/examYiman.png"
              alt=""
              class="review-icon"
            />
            <img
              v-if="item.reservationStuNum !== item.stuLimit"
              src="../assets/image/examNoman.png"
              alt=""
              class="review-icon"
            />
          </div> -->
          <div class="item-top">
            <img
              src="../assets/image/order_location.png"
              alt=""
              class="locationImg"
            />
            <p class="location">{{ item.name }}</p>
          </div>
          <p class="time">开始时间：{{ dateFormat(item.startTime) }}</p>
          <p class="time">结束时间：{{ dateFormat(item.endTime) }}</p>
          <div class="item-bottom">
            <div></div>
            <el-button
              :style="{
                backgroundColor:
                  item.reservationStuNum == item.stuLimit ||
                  passTime ||
                  myReservationStatus
                    ? 'gray'
                    : '',
              }"
              type="primary"
              size="small"
              @click="orderExam(item)"
              class="orderBut"
              >{{ item.myReservationStatus ? "已预约" : "预约" }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="isActive == 1" class="my">
      <div class="studentMessage">
        <div style="display: flex">
          <p class="school">学校：{{ stuSchool }}</p>
          <img
            v-if="$route.query.isActive != 2 && !myReservationStatus"
            @click="editMessage"
            src="../assets/image/order_img10.png"
            alt=""
            class="editImg"
          />
        </div>
        <p class="name">姓名：{{ stuName }}</p>

        <div class="messageBottom">
          <div class="num">学号：{{ stuNum }}</div>
          <!-- <el-button> 退出 </el-button> -->
          <div @click="toBack()">
            <img src="../assets/image/order_img2.png" alt="" class="backImg" />
          </div>
        </div>
      </div>

      <div
        class="myOrder"
        :class="{ 'myOrder-title': myOrderList.length == 0 }"
      >
        <div>
          <img src="../assets/image/order_img3.png" alt="" class="myImg" />
        </div>
        <div v-if="myOrderList.length > 0">
          <div
            v-for="(item, index) in myOrderList"
            :key="index"
            class="order-item"
          >
            <div class="myTop">
              <div style="display: flex; align-items: center">
                <img
                  src="../assets/image/order_location.png"
                  alt=""
                  class="locationImg"
                />
                <p class="location">{{ item.reservationItemName }}</p>
              </div>
              <div class="seatNumber">座位号：{{ item.seatNumber }}</div>
            </div>
            <p class="time">
              开始时间：{{ dateFormat(item.reservationItemStartTime) }}
            </p>
            <p class="time">
              结束时间：{{ dateFormat(item.reservationItemEndTime) }}
            </p>
            <div class="item-bottom">
              <div class="reserveTime">
                预约时间：{{ dateFormat(item.reservationTime) }}
              </div>
              <div>
                <img
                  src="../assets/image/order_img4.png"
                  alt=""
                  class="detailImg"
                  @click="seeDetail(item)"
                />
              </div>
              <!-- <el-button type="primary" size="small" @click="seeDetail(item)"
              >查看详情</el-button
            > -->
            </div>
          </div>
        </div>
        <div v-else class="noOrder">
          <img src="../assets/image/order_img9.png" alt="" class="noOrderImg" />
        </div>
      </div>
    </div>
    <div class="fixed-footer">
      <div class="footer-left" @click="tab(0)">
        <img
          v-if="isActive == 1"
          src="../assets/image/order_img5.png"
          alt=""
          class="leftImg"
        />
        <img
          v-if="isActive == 0"
          src="../assets/image/order_img6.png"
          alt=""
          class="leftImg"
        />
        <p class="title" :class="{ 'active-title': isActive === 0 }">预约</p>
      </div>
      <div class="footer-left" @click="tab(1)">
        <img
          v-if="isActive == 0"
          src="../assets/image/order_img7.png"
          alt=""
          class="leftImg"
        />
        <img
          v-if="isActive == 1"
          src="../assets/image/order_img8.png"
          alt=""
          class="leftImg"
        />
        <p class="title" :class="{ 'active-title': isActive === 1 }">我的</p>
      </div>
    </div>

    <el-dialog
      top="25vh"
      v-if="detailVisible"
      :visible.sync="detailVisible"
      :lock-scroll="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="300px"
      center
    >
      <template slot="title">
        <div>
          <div></div>
          <div
            style="
              font-size: 19px;
              font-weight: 600;
              color: black;
              padding-bottom: 10px;
              border-bottom: 1px solid #e7eaf2;
              margin-top: -5px;
            "
          >
            预约须知
          </div>
        </div>
      </template>
      <p
        style="
          display: flex;
          justify-content: center;
          margin: 0 0 5px 0;
          font-size: 19px;
          color: black;
        "
      >
        {{ selectedRow.name }}
      </p>
      <p class="dialogContent">
        &nbsp;&nbsp;&nbsp;&nbsp;{{ selectedRow.content }}
      </p>
      <div style="display: flex; justify-content: center">
        <el-button
          type="primary"
          size="small"
          style="width: 100px; border-radius: 10px; font-size: 15px"
          @click="orderExam2"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      top="25vh"
      v-if="detailVisible2"
      :visible.sync="detailVisible2"
      :lock-scroll="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="300px"
      custom-class="order-dialog"
      center
    >
      <template slot="title">
        <div>
          <div></div>
          <div
            style="
              font-size: 18px;
              font-weight: 600;
              color: black;
              padding-bottom: 10px;
              border-bottom: 1px solid #e7eaf2;
              margin-top: -5px;
            "
          >
            预约信息
          </div>
        </div>
      </template>

      <div class="message">
        <div class="left">姓名：</div>
        <div class="right">{{ stuName }}</div>
      </div>
      <div class="message">
        <div class="left">学号：</div>
        <div class="right">{{ stuNum }}</div>
      </div>
      <div class="message">
        <div class="left">时间：</div>
        <div class="right">{{ dateFormat(selectedRow.startTime) }}</div>
      </div>
      <div class="rightTime">
        {{ dateFormat(selectedRow.endTime) }}
      </div>
      <div class="message">
        <div class="left">地点：</div>
        <div class="right">{{ selectedRow.name }}</div>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 15px">
        <el-button
          type="primary"
          size="small"
          style="width: 100px; border-radius: 10px; font-size: 15px"
          @click="confirmOrder()"
          >确认预约</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      top="15vh"
      v-if="editVisible"
      :visible.sync="editVisible"
      :lock-scroll="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="360px"
      center
    >
      <template slot="title">
        <div style="display: flex; justify-content: center">
          <div></div>
          <div style="color: black">编辑</div>
        </div>
      </template>
      <div class="edti-main">
        <el-form
          :model="editForm"
          :rules="editRules"
          ref="editForm"
          label-width="70px"
          @submit.native.prevent
        >
          <el-form-item label="学校：" prop="studentSchool">
            <el-select
              v-model="editForm.studentSchool"
              style="width: calc(100% - 0px); margin: 0 0px"
              placeholder="请输入学校名称查找"
              clearable
              filterable
              :filter-method="filterSchools"
              ref="schoolSelect"
              @visible-change="handleSelectFocus"
              no-data-text="请输入学校名称"
              :popper-options="popperOptions"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item, idx) in filteredSchoolList"
                :key="idx"
                :label="item.label"
                :value="item.value"
                @touchstart.native="handleOptionTouchStart(item.value)"
                @touchend.native="handleOptionTouchEnd"
              ></el-option>
            </el-select>
            <!-- <el-select
              v-model="editForm.studentSchool"
              placeholder="请输入学校名称查找"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="(item, idx) in schoolList"
                :key="idx"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
            <!-- <el-input
              v-model.trim="editForm.studentSchool"
              size="small"
            ></el-input> -->
          </el-form-item>
          <el-form-item label="姓名：" prop="studentName">
            <el-input
              v-model.trim="editForm.studentName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="学号：" prop="studentNumber">
            <el-input
              v-model.trim="editForm.studentNumber"
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex; justify-content: center">
        <el-button
          type="primary"
          style="width: 105px; border-radius: 10px; font-size: 17px"
          @click="editConfirm"
          >确认修改</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      top="25vh"
      v-if="selectVisible"
      :visible.sync="selectVisible"
      :lock-scroll="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="300px"
      :modal="false"
      center
    >
      <template slot="title">
        <div style="display: flex; justify-content: center">
          <div></div>
          <div style="color: black">选择时间</div>
        </div>
      </template>
      <div style="display: flex; justify-content: center">
        <el-select style="width: 90%" v-model="selectedTime">
          <el-option key="全部" value="全部">全部</el-option>
          <el-option
            v-for="(timeArray, dateStr) in timeList"
            :key="dateStr"
            :value="dateStr"
            :label="dateStr"
          >
            <!-- {{ dateStr }} -->
          </el-option>
        </el-select>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 15px">
        <el-button size="small" type="primary" @click="getExamList">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/libs/api.request";
import { formatSS } from "@/utils/datetime";
export default {
  name: "OrderPage",
  data() {
    return {
      touchTimer: null,
      popperOptions: {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 10], // 调整偏移量，根据实际情况修改
            },
          },
        ],
      },
      filteredSchoolList: [], // 过滤后的学校列表
      passTime: false,
      isOverflowing: false,
      timeLength: 0,
      selectedTime: "",
      timeList: [],
      myReservationStatus: false,
      selectVisible: false,
      stuSchool: "",
      stuName: "",
      stuNum: "",
      schoolList: [],
      isActive: 0,
      expanded: false,
      examList: [],
      myOrderList: [],
      detailVisible: false,
      detailVisible2: false,
      content: "",
      title: "",
      selectedRow: {},
      editVisible: false,
      editForm: {
        studentSchool: "",
        studentName: "",
        studentNumber: "",
      },
      editRules: {
        studentSchool: [
          { required: true, message: "请输入学校名称", trigger: "change" },
        ],
        studentName: [
          { required: true, message: "请输入姓名", trigger: "change" },
        ],
        studentNumber: [
          { required: true, message: "请输入学号", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    filterSchools(query) {
      // 保存当前输入的值
      const currentInput = query;

      // 如果查询为空，显示空列表
      if (!query || query.trim() === "") {
        console.log(555);
        this.filteredSchoolList = [];
        return;
      }

      // 使用防抖处理，避免频繁过滤
      if (this.filterTimer) {
        clearTimeout(this.filterTimer);
      }

      this.filterTimer = setTimeout(() => {
        // 筛选出名称包含查询词的学校，同时保留原始数据
        this.filteredSchoolList = this.schoolList.filter(
          (item) =>
            item.value && item.value.toLowerCase().includes(query.toLowerCase())
        );

        // 确保输入框的值不会被清空
        this.$nextTick(() => {
          const input = this.$refs.schoolSelect?.$el?.querySelector("input");
          if (input && input.value !== currentInput) {
            input.value = currentInput;
          }
        });
      }, 100);
    },
    dateFormat(row) {
      return formatSS(row);
    },
    tab(val) {
      this.isActive = val;
      if (val == 0) {
        this.getExamList();
      }
      if (val == 1) {
        this.getMyOrderList();
      }
    },
    handleOptionTouchStart(value) {
      // 清除之前的定时器，防止重复触发
      clearTimeout(this.touchTimer);
      // 模拟点击：延迟触发选择逻辑
      this.touchTimer = setTimeout(() => {
        this.editForm.studentSchool = value; // 选中对应学校
        this.$refs.schoolSelect.blur(); // 关闭下拉框
      }, 100);
    },
    handleOptionTouchEnd() {
      // 清除定时器，防止触摸结束后仍触发
      clearTimeout(this.touchTimer);
    },
    getExamList() {
      const currentTime = new Date();
      const time = currentTime.getTime();
      let data = {};
      data.reservationId = this.$route.query.reservationId;
      console.log("route", this.$route);
      data.stuId = this.$route.query.uid;
      data.token = this.$route.query.token;
      data.uid = this.$route.query.uid;
      axios
        .request({
          method: "post",
          url: `${process.env.VUE_APP_BASE_URL}/exam/reservation/stu/queryInfo`,
          data: data,
        })
        .then((res) => {
          let ret = res.data;
          if (ret.code == 200) {
            if (time > ret.data.timeLimitEndTime) {
              this.passTime = true;
            }

            this.examList = ret.data.itemList;
            this.content = ret.data.content;
            this.title = ret.data.name;
            this.myReservationStatus = ret.data.myReservationStatus;
            this.timeList = ret.data.itemMap;
            this.timeLength = Object.keys(this.timeList).length;
            if (this.selectedTime && this.selectedTime != "全部") {
              const filteredList = this.examList.filter(
                (item) => item.startTimeDayStr === this.selectedTime
              );

              this.examList = filteredList;
              this.selectedTime = "";
            }
            this.selectVisible = false;
          } else {
            this.$message({
              message: ret.msg,
              type: "warning",
              duration: 2000, // 显示时间，单位毫秒
            });
            // this.$message.warning(ret.msg);
          }
        });
    },
    getMyOrderList() {
      let data = {};
      data.stuId = this.$route.query.uid;
      data.token = this.$route.query.token;
      data.uid = this.$route.query.uid;
      data.reservationId = this.$route.query.reservationId;
      axios
        .request({
          method: "post",
          url: `${process.env.VUE_APP_BASE_URL}/exam/reservationStu/queryMyPage`,
          data: data,
        })
        .then((res) => {
          let ret = res.data;
          if (ret.code == 200) {
            this.myOrderList = ret.data.records;
          }
        });
    },
    orderExam(row) {
      if (this.myReservationStatus) {
        this.$message({
          message: "您已预约！",
          type: "warning",
          duration: 2000, // 显示时间，单位毫秒
        });
        // this.$message.warning("您已预约！");
        return;
      }
      // 新增：当按钮禁用时的提示
      if (row.reservationStuNum == row.stuLimit) {
        this.$message({
          message: "该考场已约满！",
          type: "warning",
          duration: 2000, // 显示时间，单位毫秒
        });
        // this.$message.warning("该考场已约满！");
        return;
      }
      if (this.passTime) {
        this.$message({
          message: "预约时间已过！",
          type: "warning",
          duration: 2000, // 显示时间，单位毫秒
        });
        // this.$message.warning("预约时间已过！");
        return;
      }
      if (row.content) {
        this.detailVisible = true;
      } else {
        this.detailVisible2 = true;
      }
      this.selectedRow = row;
      console.log(row);
    },

    orderExam2() {
      this.detailVisible = false;
      this.detailVisible2 = true;
    },
    confirmOrder() {
      let data = {};
      data.reservationId = this.$route.query.reservationId;
      data.stuId = this.$route.query.uid;
      data.reservationItemId = this.selectedRow.reservationItemId;
      data.token = this.$route.query.token;
      data.uid = this.$route.query.uid;
      axios
        .request({
          method: "post",
          url: `${process.env.VUE_APP_BASE_URL}/exam/reservationStu/add`,
          data: data,
        })
        .then((res) => {
          let ret = res.data;
          if (ret.code == 200) {
            // console.log("res", res);
            this.$message.success("预约成功！");
            this.detailVisible2 = false;
            this.getExamList();
            this.isActive = 1;
            this.getMyOrderList();
            // this.examList = ret.data.itemList;
          } else if (ret.code == 201) {
            this.$message({
              message: ret.msg,
              type: "warning",
              duration: 2000, // 显示时间，单位毫秒
            });
            // this.$message.warning(ret.msg);
          }
        });
    },
    seeDetail(row) {
      this.$router.push({
        path: "/examDetail",
        query: {
          uid: this.$route.query.uid,
          name: this.$route.query.name,
          school: this.$route.query.school,
          num: this.$route.query.num,
          reservationId: this.$route.query.reservationId,
          isActive: this.$route.query.isActive,
          shareCode: this.$route.query.shareCode,
          reservationStuId: row.reservationStuId,
          token: this.$route.query.token,
          seatNumber: row.seatNumber,
        },
      });
    },
    toBack() {
      this.$confirm("确定要退出吗？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        dangerouslyUseHTMLString: true,
        modal: false,
        type: "warning",
        customClass: "custom-message-box",
      })
        .then(() => {
          this.$router.push({
            path: "/index",
            query: {
              shareCode: this.$route.query.shareCode,
            },
          });
        })
        .catch(() => {
          // console.log(11);
        });
      setTimeout(() => {
        const messageBox = document.querySelector(".el-message-box");
        if (messageBox) {
          messageBox.style.width = "320px";
        }
      }, 50);
    },
    handleSelectFocus(visible) {
      if (visible) {
        this.filteredSchoolList = [];
        this.$nextTick(() => {
          const input = this.$refs.schoolSelect.$el.querySelector("input");
          if (input) {
            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
              input.removeAttribute("readonly"); // 移除只读属性
              input.blur();
              setTimeout(() => {
                input.focus();
              }, 100);
            } else {
              input.focus();
            }
          }
        });
      }
    },
    editMessage() {
      this.editVisible = true;
      this.editForm.studentSchool = this.stuSchool;
      this.editForm.studentName = this.stuName;
      this.editForm.studentNumber = this.stuNum;
    },
    editConfirm() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          let data = {};
          data.uid = this.$route.query.uid;
          data.school = this.editForm.studentSchool;
          data.realName = this.editForm.studentName;
          data.number = this.editForm.studentNumber;
          data.token = this.$route.query.token;
          axios
            .request({
              method: "post",
              url: `${process.env.VUE_APP_BASE_URL}/oauth/v4/user/changeBaseInfoV2`,
              data: data,
            })
            .then((res) => {
              // console.log(res);
              let ret = res.data;
              if (ret.code == 200) {
                this.$message.success("修改成功！");
                this.stuName = ret.data.realName;
                this.stuNum = ret.data.number;
                this.stuSchool = ret.data.school;
                this.editVisible = false;
              } else {
                this.$message({
                  message: ret.msg,
                  type: "warning",
                  duration: 2000, // 显示时间，单位毫秒
                });
                // this.$message.warning(ret.msg);
              }
            });
        }
      });
    },
    getSchoolList() {
      axios
        .request({
          method: "post",
          url: `${process.env.BASE_URL_V3}/ebook/school/list`,
          data: {
            pageNo: 1,
            pageSize: 9999,
          },
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            // Authorization头会自动添加（见拦截器代码）
          },
        })
        .then((res) => {
          let ret = res.data;
          if (ret.code === 200) {
            let school = [];
            ret.data.records.forEach((element) => {
              school.push({
                value: element.name,
              });
            });
            this.schoolList = school;
          }
        });
    },
    selectTime() {
      this.selectVisible = true;
    },
    checkOverflow() {
      this.$nextTick(() => {
        const contentElement =
          this.$refs.contentContainer.querySelector(".content");
        if (contentElement) {
          // 检查内容是否超过3行
          const lineHeight = parseInt(
            getComputedStyle(contentElement).lineHeight
          );
          const maxHeight = lineHeight * 3;
          this.isOverflowing = contentElement.scrollHeight > maxHeight;
        }
      });
    },
    handlePCExam() {
      // this.$message.warning(111);
    },
    handleDisabledClick(item) {
      console.log(111);
      // 检查按钮是否处于禁用状态
      if (item.reservationStuNum == item.stuLimit) {
        this.$message({
          message: "该考场已约满！",
          type: "warning",
          duration: 2000, // 显示时间，单位毫秒
        });
        // this.$message.warning("该考场已约满！");
      } else if (this.passTime) {
        this.$message.warning("预约时间已过！");
      } else if (this.myReservationStatus) {
        this.$message({
          message: "您已预约！",
          type: "warning",
          duration: 2000, // 显示时间，单位毫秒
        });
        // this.$message.warning("您已预约！");
      }
    },
  },
  mounted() {
    if (this.$route.query.back) {
      this.isActive = 1;
      this.getMyOrderList();
    }
    this.getExamList();
    this.getSchoolList();
    // this.getMyOrderList();
    this.stuSchool = this.$route.query.school;
    this.stuName = this.$route.query.name;
    this.stuNum = this.$route.query.num;

    this.checkOverflow();
    // 监听窗口变化和内容变化
    window.addEventListener("resize", this.checkOverflow);
    this.$watch("content", this.checkOverflow);

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      const viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta) {
        viewportMeta.content =
          "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkOverflow);
  },
};
</script>

<style lang="less" scoped>
.app-main {
  display: flex;
  justify-content: center;
  height: 100vh;
}
.order-index {
  background: #ffffff;
  height: calc(100vh - 60px);
  overflow-y: auto;
  width: 100%;
  margin: 0 auto;
  max-width: 410px;
  //   padding: 15px;
  box-sizing: border-box;
  scrollbar-width: none;

  .top {
    background: url("../assets/image/order_back1.png") no-repeat;
    background-size: cover; /* 图片覆盖整个div */
    background-position: center; /* 图片居中显示 */
    background-repeat: no-repeat; /* 不重复显示 */
    padding: 10px 10px 20px 10px;
    .title {
      display: flex;
      justify-content: center;
      color: #000;
      font-size: 18px;
      margin-bottom: 15px;
      font-weight: bold;
    }

    .content-container {
      position: relative;
      padding-right: 20px; /* 为展开按钮留出空间 */

      .content {
        margin: 0;
        line-height: 1.8;
        text-align: justify;
        text-indent: 2em; /* 段落首行缩进2字符 */
        transition: all 0.3s ease;

        &.collapsed {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .toggle-btn {
        position: absolute;
        right: 0;
        bottom: 0;
        color: #1890ff;
        background: none;
        border: none;
        padding: 5px 10px;
        font-size: 14px;
        cursor: pointer;
        border-radius: 4px;

        &:hover {
          background-color: #f0f7ff;
        }
      }
    }
  }
  .zhong {
    background: url("../assets/image/order_back2.png") no-repeat;
    background-size: cover; /* 图片覆盖整个div */
    background-position: center; /* 图片居中显示 */
    background-repeat: no-repeat; /* 不重复显示 */
    color: white;
    margin-top: -10px;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    padding: 10px;
    height: 45px;
    .tishi {
      display: flex;
      padding-top: 4px;
      padding-left: 10px;
    }
    .timeImg {
      cursor: pointer;
      width: 100px;
    }
  }
  .bottom {
    padding: 10px;
    scrollbar-width: none;
    margin-top: -15px;
    border-radius: 15px;
    // background: linear-gradient(180deg, #edf5fc 0%, #fcfdfe 100%);
    background: #edf5fc;
    height: calc(100vh - 235px);

    .bottom-item {
      background: url("../assets/image/order_back3.png") no-repeat !important;
      background-size: cover !important; /* 图片覆盖整个div */
      background-position: center !important; /* 图片居中显示 */
      background-repeat: no-repeat !important; /* 不重复显示 */
      //   box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
      width: calc(100% - 40px);
      margin-top: 20px;
      border-radius: 10px;
      margin-left: 10px;
      padding: 0 20px 20px 20px;
      position: relative;
      .review-badge {
        position: absolute;
        top: -5px;
        right: 10px;
        width: 60px;
        height: 60px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;

        .review-icon {
          width: 52px;
          height: 53px;
          object-fit: contain;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
        }
      }
      //   background: white;
      .item-top {
        display: flex;
        // margin-top: -10px;
        margin: 10px 20px 0 0;
        border-bottom: 1px solid #eeeef1;
        padding-bottom: 5px;
        padding-top: 10px;
        align-items: center;
        .locationImg {
          width: 70px;
          height: 27px;
          // margin-top: 10px;
        }
        .location {
          color: #000;
          margin: 0px 0 0 6px !important;
          font-size: 16px;
        }
      }

      .time {
        color: #62646b;
        margin: 10px 0 10px 0;
      }
      .item-bottom {
        display: flex;
        justify-content: space-between;
        padding: 0 10px 0 10px;
        align-items: center;
        .orderBut {
          border-radius: 20px;
          width: 90px;
        }
      }
    }
  }
  .my {
    padding: 10px;
    background: #edf5fc;
    // height: 100vh;
    height: calc(100vh - 60px);
    .studentMessage {
      background: url("../assets/image/order_back4.png") no-repeat !important;
      background-size: cover !important; /* 图片覆盖整个div */
      background-position: center !important; /* 图片居中显示 */
      background-repeat: no-repeat !important; /* 不重复显示 */
      // background: blue;
      padding: 10px 10px 10px 20px;
      color: white;
      border-radius: 8px;
      .school {
        margin: 0 0 0 0;
      }
      .editImg {
        cursor: pointer;
        width: 22px;
        height: 22px;
        margin-left: 10px;
      }
      .name {
        margin: 10px 0 5px 0;
      }
      .messageBottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .num {
          // margin-top: 10px;
        }
        .backImg {
          cursor: pointer;
          width: 70px;
        }
      }
    }
    .myImg {
      width: 190px;
      padding: 10px;
    }

    .noOrder {
      display: flex;
      justify-content: center;
      padding-top: 100px;
      .noOrderImg {
        width: 250px;
      }
    }

    .myOrder {
      margin-top: 10px;
      border: 1px solid white;
      border-radius: 10px;
      &.myOrder-title {
        border-radius: 10px 150px 10px 10px;
      }
      .order-item {
        background: white;
        padding: 10px 10px 10px 10px;
        margin: 0 10px 10px 10px;
        border-radius: 10px;
        .myTop {
          display: flex;
          justify-content: space-between;
          padding-right: 15px;
          border-bottom: 1px solid #eeeef1;
          align-items: center;
          padding-bottom: 5px;

          .locationImg {
            width: 70px;
            height: 27px;
          }

          .location {
            color: #000;
            margin: 0px 0 0px 6px;
          }
          .seatNumber {
            color: #000;
            min-width: 80px;
          }
        }
        .time {
          color: #62646b;
        }
        .item-bottom {
          display: flex;
          justify-content: space-between;
          padding: 0 0 0 10px;
          align-items: center;
          .reserveTime {
            background: #f5f5f5;
            border-radius: 10px;
            color: #1890ff;
            padding: 5px;
            font-size: 13px;
          }
        }
        .detailImg {
          width: 100px;
          cursor: pointer;
        }
      }
    }
  }
  .fixed-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: white;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
    max-width: 410px;
    // max-width: none;
    // width: 100%;
    margin: 0 auto;
    .footer-left {
      cursor: pointer;
      .leftImg {
        width: 30px;
      }
      .title {
        margin: -5px 0 0 0;
        &.active-title {
          color: #1890ff; /* 激活时颜色 */
        }
      }
    }
    .btn-reserve {
      background: #1890ff;
      color: white;
      border: none;
      padding: 10px 25px;
      border-radius: 20px;
      margin: 0 10px;
      font-size: 16px;
    }

    .btn-mine {
      background: white;
      color: #1890ff;
      border: 1px solid #1890ff;
      padding: 10px 25px;
      border-radius: 20px;
      margin: 0 10px;
      font-size: 16px;
    }
  }
}

@media (max-width: 768px) {
  .order-index {
    max-width: 100%; /* 手机端占满宽度 */
  }
}

::v-deep .el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 5px 20px 20px 20px;
  font-size: 16px;
}
.dialogContent {
  font-size: 15px;
  margin: 0 0 15px 0;
}
.message {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  margin: 10px 0 0 0;
  .left {
    min-width: 50px;
  }
  .right {
    color: #333333;
    font-weight: 600;
    max-width: 180px;
  }
}
.rightTime {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
  color: #333333;
  font-weight: 600;
}

.order-dialog {
  border-radius: 15px; /* 对话框圆角 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2); /* 阴影效果 */
}

::v-deep .el-dialog {
  border-radius: 15px !important; /* !important 确保覆盖默认样式 */
}
// /* 在全局样式文件中添加 */
// .el-message-box {
//   width: 320px !important;
// }

// /* 或者更具体的选择器 */
// .el-message-box__wrapper .el-message-box {
//   width: 320px !important;
// }
</style>